import { MapRef } from 'react-map-gl/mapbox'

import { MapStyleToggles as SharedMapStyleToggles } from '@/lib/map/MapStyleToggles'

import { useTrackerMapContext } from './TrackerMapContext'

interface MapStyleTogglesProps {
  mapRef: React.RefObject<MapRef | null>
  onChangeStyle: () => void
}

export const MapStyleToggles = ({ mapRef, onChangeStyle }: MapStyleTogglesProps) => {
  const context = useTrackerMapContext()

  return (
    <SharedMapStyleToggles
      className="top-28 md:top-4 right-4"
      style={context.mapState.style}
      onChange={(style, { pitch, bearing }) => {
        onChangeStyle()
        const map = mapRef.current?.getMap?.()
        if (map) {
          map.setPitch(pitch)
          map.setBearing(bearing)
        }
        context.setMapState({ ...context.mapState, style, pitch, bearing })
      }}
    />
  )
}
